/* eslint-disable import/no-anonymous-default-export */
export default {
  path: "/policy-updates",
  shortTitle: "Policy updates",
  title: "Policy updates and contact changes",
  category: "Data and website",
  summary: "How material policy changes are dated, communicated and reconciled with orders already placed.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "When policies change",
      body: [
        "Policies may be revised when catalog materials, safety guidance, checkout fields, payment flow, delivery destinations, customer rights or business information change. A correction may also be needed when wording is incomplete or a legal requirement changes.",
      ],
    },
    {
      heading: "Version information",
      body: [
        "Each policy shows a latest-update date. A material change should be written into the relevant policy rather than hidden in a generic notice. Where reasonable, a prominent storefront message may call attention to a change that affects an active customer decision. Archived terms applicable to a disputed order should be preserved in merchant records when available.",
      ],
    },
    {
      heading: "Effect on existing orders",
      body: [
        "A later policy will not be used to retroactively remove a price, accepted order term or mandatory right. Operational instructions may still change where required for safety, security, law or a mutually agreed resolution. Order-specific written commitments remain relevant to the affected order.",
      ],
    },
    {
      heading: "Business-information checklist",
      body: [
        "A move of operating country or address triggers one coordinated review: About, Contact and Footer; privacy-location statements; delivery, customs and tax copy; currency and time zone; date and number formatting; search metadata; and the central configuration. To query a mismatch, send customer care the relevant page address and policy name.",
      ],
    },
  ],
};
